import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import { Button, Label, Select, Loader, FileInput } from 'oxyrion-ui/lib';
import { __ } from '../../../../Utils';
import { connect, actions } from '../../../../Store';
import { Title } from '../../../../Components/ReusableComponents';
import API2 from '../../../../API2';
import DatePicker from '../../../../Components/DatePicker';
import APICustom from '../../../../APICustom';

const MainContainer = styled.div`
  padding: ${rem(16)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const InputWrapper = styled.div`
  padding: 10px 0px;
  width: ${rem(644)};
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: ${rem(670)};
`;

const CustomButton = styled(Button)`
  margin: 0 ${rem(10)};
  width: ${rem(100)};
`;

const acceptedMimeTypes = ['application/pdf'];

class SecurityCertificatesDetail extends React.Component {
  constructor() {
    super();
    this.state = {
      loader: true,
      selected: null,
      valid_from: moment(),
      valid_to: null,
      file: { fileValue: '', file: null, fileError: false },
    };
  }

  async componentDidMount() {
    await this.fetch();

    actions.setActiveMenuItem('94');
  }

  async onSubmit() {
    // eslint-disable-next-line camelcase
    const { selected, valid_from, valid_to, file } = this.state;
    const { firm, user } = this.props;

    this.setState({
      saveLoading: true,
    });
    // eslint-disable-next-line camelcase
    if (selected && valid_from && valid_to && file.file) {
      const response = await API2.postB2BCustomerSecurityCertificateAction(
        firm,
        user.customer._id,
        { body: { certificateTypeId: selected, valid_from, valid_to } },
      );

      await APICustom.postB2BCustomerSecurityCertificatePDFActionCustom(
        firm,
        response.certificateId,
        { body: { file: file.file } },
      );
    } else {
      alert(__('Je potrebné vyplniť všetky polia'));
    }

    this.setState({
      saveLoading: false,
    });
  }

  async fetch() {
    this.setState({ loader: true });
    try {
      const certificatesTypes = await API2.getB2BSecurityCertificatesAction(
        this.props.firm,
      );

      this.setState({
        certificatesTypes: certificatesTypes.items,
        loader: false,
      });
    } catch (e) {
      this.setState({ loader: false });
      this.props.history.push('/settings/certificates');
    }
  }

  handleChange(type, value) {
    let { selected, valid_from, valid_to } = this.state;

    if (type === 'selected') {
      selected = value;
    }

    if (type === 'valid_from') {
      valid_from = value;
    }

    if (type === 'valid_to') {
      valid_to = value;
    }

    if (type === 'file') {
      if (value.length) {
        const f = value[0];
        if (!acceptedMimeTypes.includes(f.type)) {
          this.setState({ error: __('Zlý formát súboru.') });
        } else {
          const file = {
            fileValue: f.name,
            file: f,
            fileError: false,
            errors: [],
          };
          this.setState({
            file,
          });
        }
      }
    }

    this.setState({
      selected,
      valid_from,
      valid_to,
    });
  }

  removeFile() {
    this.setState({
      file: { fileValue: '', file: null, fileError: false },
    });
  }

  render() {
    const {
      certificatesTypes,
      loader,
      selected,
      valid_from,
      valid_to,
      file,
      saveLoading,
    } = this.state;

    if (loader) {
      return (
        <MainContainer>
          <Loader size="xl" />
        </MainContainer>
      );
    }

    return (
      <MainContainer>
        <Title>{__('Pridať nový certifikát')}</Title>

        <InputWrapper>
          <Label>{__('Typ ceritifkátu*')}</Label>
          <Select
            icon="arrow-down"
            iconRight
            value={selected}
            onChange={e => this.handleChange('selected', e.target.value)}
          >
            <option value="">{__('Vyberte možnosť')}</option>
            {certificatesTypes.map(s => {
              return (
                <option selected={s._id === selected} value={s._id}>
                  {s.name}
                </option>
              );
            })}
          </Select>
        </InputWrapper>

        <InputWrapper>
          <Label>{__('Platný od*')}</Label>
          <DatePicker
            // hidden={item.hidden}
            // error={item.error}
            dateFormat="DD.MM.YYYY"
            // disabled={item.disabled}
            selected={valid_from}
            onChange={val => this.handleChange('valid_from', val)}
          />
        </InputWrapper>

        <InputWrapper>
          <Label>{__('Platný do*')}</Label>
          <DatePicker
            // hidden={item.hidden}
            // error={item.error}
            dateFormat="DD.MM.YYYY"
            // disabled={item.disabled}
            selected={valid_to}
            onChange={val => this.handleChange('valid_to', val)}
          />
        </InputWrapper>

        <InputWrapper>
          <Label>{__('PDF súbor*')}</Label>
          <FileInput
            style={{
              width: '90%',
            }}
            item={file.fileValue}
            onChange={e => this.handleChange('file', e.target.files)}
            onRemoveFile={() => this.removeFile()}
          />
        </InputWrapper>
        <ButtonWrapper>
          <CustomButton
            danger
            onClick={() => {
              window.scrollTo({
                top: 0,
                behavior: 'smooth',
              });
              this.props.history.push('/settings/certificates');
            }}
          >
            {__('Zrušiť')}
          </CustomButton>
          <CustomButton
            primary
            loading={saveLoading}
            disabled={saveLoading}
            onClick={() => this.onSubmit()}
          >
            {__('Uložiť')}
          </CustomButton>
        </ButtonWrapper>
      </MainContainer>
    );
  }
}

SecurityCertificatesDetail.PropTypes = {
  location: PropTypes.shape.isRequired,
  user: PropTypes.shape({}).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(SecurityCertificatesDetail);



// WEBPACK FOOTER //
// ./src/Containers/Settings/SecurityCertificates/Detail/index.jsx